import { JsonDataType } from "..";

export const isJsonValid = (json: string) => {
    try {
        JSON.parse(json);
        return true
    }
    catch (e) {
        return false
    }
}

interface JsonDataTypeParseResult {
    result: boolean
    jsonParsedData: JsonDataType
}


export const parseJsonData = (jsonData: string) => {
    let replacedJson = jsonData
    let parsedJsonData: JsonDataTypeParseResult = { result: false, jsonParsedData: { "Raw Data": jsonData } }

    if (!isJsonValid(jsonData)) {
        replacedJson = replacedJson.replace(/`/g, '"')
        if (isJsonValid(replacedJson)) {
            parsedJsonData = { result: true, jsonParsedData: JSON.parse(replacedJson) }


        }
    } else {
        parsedJsonData = { result: true, jsonParsedData: JSON.parse(replacedJson) }
    }

    return parsedJsonData
}